<template>
  <div class="admin">
    <div class="admin-container2"
      v-if="getUser.user != null && (getUser.user.role === 'SuperAdmin' || getUser.user.role === 'Admin')">
      <!-- admin content -->
      <el-row class="admin-pannel">
        <el-col :span="12" :offset="6">
          <el-col :span="11">
            <el-button @click="showAdminContent('SignUp')">Create new user</el-button>
          </el-col>
          <el-col :span="2"> - </el-col>
          <el-col :span="11">
            <el-button @click="logout">Logout</el-button>
          </el-col>
        </el-col>
      </el-row>
      <el-row class="admin-pannel">
        <el-col :span="12" :offset="6">
          <el-col :span="11">
            <el-button @click="showAdminContent('StatsPerm')">Stats Restos</el-button>
          </el-col>
          <el-col :span="2"> - </el-col>
          <el-col :span="11">
            <el-button @click="getRestosInfos()">Admin Restos</el-button>
          </el-col>
        </el-col>
      </el-row>
      <el-row class="admin-pannel">
        <el-col :span="12" :offset="6">
          <el-col :span="11">
            <el-button @click="getGoogleRestosInfos()">Google Reservit</el-button>
          </el-col>
          <el-col :span="2"> - </el-col>
          <el-col :span="11">
            <el-button @click="showAdminContent('Stripe')">Stripe</el-button>
          </el-col>
        </el-col>
      </el-row>
      <el-row class="admin-pannel">
        <el-col :span="12" :offset="6">
          <el-col :span="11">
            <el-button @click="getAppInfos()">AppInfos</el-button>
          </el-col>
        </el-col>
      </el-row>

      <!-- SuperAdmin content -->
      <el-row class="admin-pannel" v-if="superAdmin">
        <el-col :span="12" :offset="6">
          <el-col :span="11">
            <el-button @click="changeMailLogin">Action</el-button>
          </el-col>
          <el-col :span="2"> - </el-col>
          <el-col :span="11">
            <el-button @click="showAdminContent('Auth')">Auth debug</el-button>
          </el-col>
        </el-col>
      </el-row>

      <!-- Admin Restos -->
      <el-row class="logapp" v-if="this.panelShow === 'AdminResto'">
        <el-col :span="20" :offset="2" class="logapp-container2">
          <el-row class="admin-resto-content">
            <div class="admin-resto-title">Administration des restaurants</div>
            <el-col>
              <el-row style="padding:10px">
                <el-col :span="12">
                  <el-input v-model="searchResto" placeholder="Rechercher par nom restaurant">
                    <i class="el-icon-search el-input__icon" slot="prefix"></i>
                  </el-input>
                </el-col>
                <el-col :offset="1" :span="11">
                  <el-select v-model="typeResto" placeholder="Type de restaurant">
                    <el-option v-for="item in optionsType" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>

            <!-- header -->
            <el-col class="admin-resto-line admin-resto-line_header">
              <el-row>
                <el-col :span="4">Nom resto</el-col>
                <el-col :span="2">Permanence</el-col>
                <el-col :span="2">Mail resto</el-col>
                <el-col :span="2">Sms client</el-col>
                <el-col :span="2">Sms rappel</el-col>
                <el-col :span="2">Caution/Pré.</el-col>
                <el-col :span="3"></el-col>
                <el-col :span="4"></el-col>
                <el-col :span="3"></el-col>
              </el-row>
            </el-col>
            <!-- values -->
            <el-col v-for="(resto, index) in getFilteredRestoInfos" :key="index" class="admin-resto-line">
              <el-row>
                <el-col :span="4">{{ resto.restoName }}</el-col>
                <el-col :span="2">
                  <el-switch v-model="resto.permanenceOn" active-color="#00cec0" inactive-color="#e95d5d">
                  </el-switch>
                </el-col>
                <el-col :span="2">
                  <el-switch v-model="resto.restoMailSended" active-color="#00cec0" inactive-color="#e95d5d">
                  </el-switch>
                </el-col>
                <el-col :span="2">
                  <el-switch v-model="resto.clientSmsSended" active-color="#00cec0" inactive-color="#e95d5d">
                  </el-switch>
                </el-col>
                <el-col :span="2">
                  <el-switch v-model="resto.rappelSmsSended" active-color="#00cec0" inactive-color="#e95d5d">
                  </el-switch>
                </el-col>
                <el-col :span="2">
                  <el-switch v-model="resto.restoStripe" active-color="#00cec0" inactive-color="#e95d5d">
                  </el-switch>
                </el-col>
                <el-col :span="3">
                  <el-button type="primary"
                    @click="modifyRestoOption(index, resto.permanenceOn, resto.restoMailSended, resto.clientSmsSended, resto.rappelSmsSended, resto.restoStripe)">Valider</el-button>
                </el-col>
                <el-col :span="4">
                  <el-button type="primary" @click="modifyPWD(index, resto.restoid)">Modifier PWD</el-button>
                </el-col>
                <el-col :span="3">
                  <el-button type="danger" @click="deleteResto(index, resto.restoName)">Supprimer</el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <!-- Stats Perm screen -->
      <el-row class="logapp" v-if="this.panelShow === 'StatsPerm'">
        <el-col :span="20" :offset="2" class="logapp-container2">
          <el-row class="dateChooser">
            <el-col :span="7" :offset="2">
              <el-date-picker class="datePicker" ref="picker" v-model="valueMinCalendar" format="dd/MM/yyyy" type="date"
                placeholder="Choisissez la date de départ" />
            </el-col>
            <el-col :span="7" :offset="2">
              <el-date-picker class="datePicker" ref="picker" v-model="valueMaxCalendar" format="dd/MM/yyyy" type="date"
                placeholder="Choisissez la date d'arrivé" />
            </el-col>
            <el-col :span="4" :offset="2">
              <el-button type="primary" @click="getStatsPermDatas()">Voir les stats</el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row class="logapp" v-if="this.panelShow === 'StatsPerm'">
        <el-col :span="20" :offset="2" class="logapp-container2">
          <el-row class="dateChooser" v-loading="statLoading">
            <div style="width:100%; text-align: center; margin:10px 0">
              <el-button v-if="getStatsTable.length > 0" @click="exportStats()">Télécharger les stats</el-button>
            </div>
            <el-table v-if="getStatsTable.length > 0" :default-sort="{ prop: 'total', order: 'descending' }"
              :data="getStatsTable" stripe style="width: 100%">
              <el-table-column prop="name" sortable label="Nom resto" width="220">
              </el-table-column>
              <el-table-column prop="email" sortable label="login" width="220">
              </el-table-column>
              <el-table-column prop="total" sortable label="Résas" width="70">
              </el-table-column>
              <el-table-column prop="nbSms" sortable label="Sms" width="70">
              </el-table-column>
              <!-- permanence -->
              <el-table-column label="Permanence" width="300">
                <el-table-column prop="permanenceTotal" sortable label="Total" width="100" />
                <el-table-column prop="permanenceNoShow" sortable label="NoShow" width="100" />
                <el-table-column prop="permanenceCancel" sortable label="Annul." width="100" />
              </el-table-column>
              <!-- resto -->
              <el-table-column label="Restaurant" width="300">
                <el-table-column prop="restoTotal" sortable label="Total" width="100" />
                <el-table-column prop="restoNoShow" sortable label="NoShow" width="100" />
                <el-table-column prop="restoCancel" sortable label="Annul." width="100" />
              </el-table-column>
              <!-- web -->
              <el-table-column label="Site web" width="300">
                <el-table-column prop="webTotal" sortable label="Total" width="100" />
                <el-table-column prop="webNoShow" sortable label="NoShow" width="100" />
                <el-table-column prop="webCancel" sortable label="Annul." width="100" />
              </el-table-column>
              <!-- google -->
              <el-table-column label="Google" width="300">
                <el-table-column prop="googleTotal" sortable label="Total" width="100" />
                <el-table-column prop="googleNoShow" sortable label="NoShow" width="100" />
                <el-table-column prop="googleCancel" sortable label="Annul." width="100" />
              </el-table-column>
              <!-- insta -->
              <el-table-column label="Instagram" width="300">
                <el-table-column prop="instagramTotal" sortable label="Total" width="100" />
                <el-table-column prop="instagramNoShow" sortable label="NoShow" width="100" />
                <el-table-column prop="instagramCancel" sortable label="Annul." width="100" />
              </el-table-column>
              <!-- facebook -->
              <el-table-column label="Facebook" width="300">
                <el-table-column prop="facebookTotal" sortable label="Total" width="100" />
                <el-table-column prop="facebookNoShow" sortable label="NoShow" width="100" />
                <el-table-column prop="facebookCancel" sortable label="Annul." width="100" />
              </el-table-column>
            </el-table>
            <el-col>
              Restaurants traité : {{ Object.entries(getStats).length }}
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <!-- app infos -->
      <el-row class="logapp" v-if="this.panelShow === 'AppInfos'">
        <el-col :span="20" :offset="2" class="logapp-container2">
          <el-button icon="el-icon-close" circle @click="showAdminContent('')"></el-button>
          <div class="logapp-panel">
            <h3>Infos de l'Application</h3>
            <el-form ref="formAppInfos" :model="formAppInfos" label-width="120px">
              <el-row v-loading="appInfosLoading">
                <el-col :md="9" :sm="20" :xs="20" :offset="2">
                  <el-form-item prop="version" :rules="[
                    { required: true, message: 'Merci de rentrer une version', trigger: 'blur' }
                  ]">
                    <el-input placeholder="version" v-model="formAppInfos.version" />
                  </el-form-item>
                </el-col>
                <el-col :span="9" :offset="2">
                  <el-col>
                    <span>Accès permanence test de l'ip : </span>
                    <el-switch v-model="formAppInfos.ipsCheck" active-color="#00cec0" inactive-color="#e95d5d">
                    </el-switch>
                  </el-col>
                </el-col>
                <el-col :md="20" :sm="20" :xs="20" :offset="2" v-for="(ip, index) in formAppInfos.ips" :key="index">
                  <el-form-item :rules="[
                    { required: true, message: 'Merci de rentrer une ip', trigger: 'blur' }
                  ]">
                    <el-input placeholder="ip adresse : 192.168.0.1" v-model="formAppInfos.ips[index]" />
                  </el-form-item>
                </el-col>
                <el-col :span="12" :offset="12">
                  <el-form-item>
                    <el-button type="info" @click="formAppInfos.ips.push('')">Ajouter une ip</el-button>
                  </el-form-item>
                </el-col>
                <el-col>
                  <el-form-item>
                    <el-button type="primary" @click="saveAppInfos()">Sauvegarder</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-col>
      </el-row>

      <!-- stripe -->
      <el-row class="logapp" v-if="this.panelShow === 'Stripe'">
        <el-col :span="20" :offset="2" class="logapp-container2">
          <el-row class="dateChooser">
            <el-col :span="7" :offset="2">
              <el-date-picker class="datePicker" ref="picker" v-model="valueMinCalendar" format="dd/MM/yyyy" type="date"
                placeholder="Choisissez la date de départ" />
            </el-col>
            <el-col :span="4" :offset="2">
              <el-button type="primary" @click="getStripeDatas()">Voir les stats</el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-row class="logapp" v-if="this.panelShow === 'Stripe'">
        <el-col :span="20" :offset="2" class="logapp-container2">
          <el-row class="dateChooser" v-loading="stripeLoading">
            <div style="width:100%; text-align: center; margin:10px 0">
              <el-button v-if="getStripeTable.length > 0" @click="exportStatsStripe()">Télécharger les stats
                stripe</el-button>
            </div>
            <el-table v-if="getStripeTable.length > 0" :default-sort="{ prop: 'total', order: 'descending' }"
              :data="getStripeTable" stripe style="width: 100%">
              <el-table-column prop="name" sortable label="Nom resto" width="220">
              </el-table-column>
              <el-table-column prop="email" sortable label="login" width="220">
              </el-table-column>
              <!-- Caution -->
              <el-table-column label="Cautions" width="300">
                <el-table-column prop="nbResaCaution" sortable label="Nb" width="100" />
                <el-table-column prop="nbResaCautionPaid" sortable label="Nb Soldé" width="100" />
                <el-table-column prop="nbResaCautionUnPaid" sortable label="Nb Non Soldé" width="100" />
                <el-table-column prop="amountCautionUnPaid" sortable label="En attente" width="100" />
                <el-table-column prop="amountCautionPaid" sortable label="Facturé" width="100" />
              </el-table-column>
              <!-- Prépaiement -->
              <el-table-column label="Prépaiement" width="300">
                <el-table-column prop="nbResaPrepaiement" sortable label="Nb" width="100" />
                <el-table-column prop="nbResaPrepaiementPaid" sortable label="Nb Soldé" width="100" />
                <el-table-column prop="nbResaPrepaiementUnPaid" sortable label="Nb Non Soldé" width="100" />
                <el-table-column prop="amountPrepaiementUnPaid" sortable label="En attente" width="100" />
                <el-table-column prop="amountPrepaiementPaid" sortable label="Facturé" width="100" />
              </el-table-column>
              <!-- resto -->
              <el-table-column prop="total" sortable label="Total général facturé" width="220">
              </el-table-column>
            </el-table>
            <el-col>
              Restaurants traité : {{ Object.entries(getStripeTable).length }}
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <!-- Create new resto -->
      <el-row class="logapp" v-if="this.panelShow === 'SignUp'">
        <el-col :span="20" :offset="2" class="logapp-container2">
          <el-button icon="el-icon-close" circle @click="showAdminContent('')"></el-button>
          <div class="logapp-panel">
            <h3>Créer un compte</h3>
            <el-form ref="formSignUp" :rules="rulesForm" :model="formSignUp" label-width="120px">
              <el-row>
                <el-col :md="9" :sm="20" :xs="20" :offset="2">
                  <el-form-item prop="email">
                    <el-input placeholder="'email > login'" v-model="formSignUp.email" />
                  </el-form-item>
                  <el-form-item prop="name">
                    <el-input placeholder="Nom" v-model="formSignUp.name" />
                  </el-form-item>
                  <el-form-item prop="secondname">
                    <el-input placeholder="Prénom" v-model="formSignUp.secondname" />
                  </el-form-item>
                  <el-form-item prop="adresse">
                    <el-input placeholder="Adresse" v-model="formSignUp.adresse" />
                  </el-form-item>
                  <el-form-item prop="adresse">
                    <el-input placeholder="Code postal" v-model="formSignUp.cpVille" />
                  </el-form-item>
                  <el-form-item prop="adresse">
                    <el-input placeholder="Ville" v-model="formSignUp.ville" />
                  </el-form-item>
                  <el-form-item>
                    <el-select v-model="formSignUp.langue" placeholder="Langue">
                      <el-option v-for="item in langueOptions" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-select v-model="formSignUp.type" placeholder="Type">
                      <el-option v-for="item in restaurantType" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :md="9" :sm="20" :xs="20" :offset="2">
                  <el-form-item prop="info">
                    <el-input placeholder="Nom du restaurant" v-model="formSignUp.restoName" />
                  </el-form-item>
                  <el-form-item prop="info">
                    <el-input placeholder="Forme juridique" v-model="formSignUp.formejuridique" />
                  </el-form-item>
                  <el-form-item prop="info">
                    <el-input placeholder="Dénomination" v-model="formSignUp.denomination" />
                  </el-form-item>
                  <el-form-item prop="info">
                    <el-input placeholder="SIRET" v-model="formSignUp.siret" />
                  </el-form-item>
                  <el-form-item prop="info">
                    <el-input placeholder="N° TVA" v-model="formSignUp.tva" />
                  </el-form-item>
                  <el-form-item prop="info">
                    <el-input placeholder="Site web" v-model="formSignUp.web" />
                  </el-form-item>
                  <el-form-item prop="codera">
                    <el-input placeholder="Code RA" v-model="formSignUp.codera" />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item prop="password" style="width: 60%; margin: 0 auto 20px !important;">
                <el-input placeholder="Mot de passe" v-model="formSignUp.password" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="signUp('formSignUp')">Créer</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>

      <!-- Google info -->
      <el-row class="logapp" v-if="this.panelShow === 'Google'">
        <el-col :span="20" :offset="2" class="logapp-container2">
          <el-tabs tab-position="left">
            <el-tab-pane v-for="(resto, index) in restosInfos" :key="index" :label="resto.restoName">
              <h3>{{ resto.restoName }}</h3>
              <el-form ref="formGoogle" :rules="rulesForm" :model="resto" label-width="120px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item>
                      <el-input placeholder="Web" v-model="resto.restoWeb" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item>
                      <el-input placeholder="Téléphone" v-model="resto.restoTelGoogle" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item>
                      <el-input placeholder="Latitude" v-model="resto.restoLat" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item>
                      <el-input placeholder="Longitude" v-model="resto.restoLong" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item>
                      <el-input placeholder="Ville" v-model="resto.restoCity" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item>
                      <el-input placeholder="Code postale" v-model="resto.restoPostalCode" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item>
                      <el-input placeholder="Adresse" v-model="resto.restoAddress" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item>
                      <el-input placeholder="Region" v-model="resto.restoRegion" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item>
                      <el-input placeholder="Pays" v-model="resto.restoCountry" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item>
                  <el-button type="primary" @click="updateGoogleInfos(resto)">Sauvegarder</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>

      <el-dialog title="Changement de mot de passe" :visible.sync="changePWD" width="50%">
        <el-form :model="formPWD" v-if="formPWD.canModifyPWD !== canModifyPWD">
          <el-form-item label="Déverouillez le formulaire de changement de mot de passe">
            <el-input v-model="formPWD.canModifyPWD"></el-input>
          </el-form-item>
        </el-form>
        <el-form ref="formPWDChange" :rules="rulesFormPWDChange" :model="formPWDChange"
          v-if="formPWD.canModifyPWD === canModifyPWD">
          <div style="margin-bottom: 10px">Pour :<br>{{ formPWDChange.email }}</div>
          <el-form-item label="Nouvel email" prop="newEmail" required>
            <el-input v-model="formPWDChange.newEmail"></el-input>
          </el-form-item>
          <el-form-item label="Nouveau mot de passe" prop="newPassword" required>
            <el-input v-model="formPWDChange.newPassword"></el-input>
          </el-form-item>
          <el-form-item label="Retaper le nouveau mot de passe" prop="newPasswordCheck" required>
            <el-input v-model="formPWDChange.newPasswordCheck"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="closeChangePWD()">Annuler</el-button>
            <el-button type="primary" :disabled="formPWD.canModifyPWD !== canModifyPWD"
              @click="submitFormPWD('formPWDChange')">Confirmer</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <!-- Auth info -->
      <div class="admin-console" v-if="this.panelShow === 'Auth'">
        <vue-json-pretty :path="'res'" :deep="3" :data="getUser">
        </vue-json-pretty>
      </div>
    </div>
  </div>
</template>

<script>
import { Notification } from 'element-ui'
import _ from 'lodash'
import Papa from 'papaparse'
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { ERequestType, fetchGetHelper, fetchPostHelper, fetchPutHelper } from '../tools/fetch'
import { dateToTimeStamp } from '../tools/timeTool'
import Services from './services/Services'

export default {
  name: 'AdminPannel',
  data() {
    return {
      superAdmin: false,
      ipControlEnable: true,
      loading: true,
      searchResto: '',
      typeResto: '',
      optionsType: [
        {
          value: '',
          label: 'Tous'
        },
        {
          value: 'classique',
          label: 'Classique'
        }
      ],
      editableUserList: [],
      roleSettableList: [],
      langueOptions: {},
      restaurantType: {},
      restosInfos: {},
      stats: {},
      statsTable: {},
      stripeTable: {},
      statLoading: false,
      appInfosLoading: false,
      stripeLoading: false,
      statsVisibility: false,
      changePWD: false,
      valueMinCalendar: '',
      valueMaxCalendar: '',
      canModifyPWD: '11Emeraude!!',
      formPWD: {
        canModifyPWD: ''
      },
      formPWDChange: {
        email: '',
        newEmail: '',
        newPassword: '',
        newPasswordCheck: ''
      },
      formSignUp: {
        email: '',
        name: '',
        secondname: '',
        adresse: '',
        langue: 'fr',
        restoName: '',
        formejuridique: '',
        denomination: '',
        siret: '',
        tva: '',
        web: '',
        codera: '',
        password: '',
        type: 'classique'
      },
      formAppInfos: {
        version: '',
        ipsCheck: true,
        ips: []
      },
      formGoogle: {
        restoTelGoogle: '',
        restoWeb: '',
        restoLat: '',
        restoLong: '',
        restoCity: '',
        restoCountry: '',
        restoRegion: '',
        restoAddress: '',
        restoPostalCode: ''
      },
      rulesForm: {},
      rulesFormAppInfos: {},
      panelShow: '',
      interval: null
    }
  },
  computed: {
    ...mapGetters({
      getUser: 'newUsers/getUser',
      getnewUser: 'newUsers/getUser',
      getAUsers: 'newUsers/getAUsers'
    }),
    getStats() {
      this.statsTable = this.getStatsFormatted()
      return this.stats
    },
    getStatsTable() {
      return this.statsTable
    },
    getStripeTable() {
      let tab = []
      Object.entries(this.stripeTable).forEach(([id, esta]) => {
        let tmp = {
          name: esta.name,
          email: esta.email,
          nbResaCaution: esta.nbResaCaution,
          nbResaCautionPaid: esta.nbResaCautionPaid,
          nbResaCautionUnPaid: esta.nbResaCautionUnPaid,
          amountCautionUnPaid: esta.amountCautionUnPaid + '€',
          amountCautionPaid: esta.amountCautionPaid + '€',
          nbResaPrepaiement: esta.nbResaPrepaiement,
          nbResaPrepaiementPaid: esta.nbResaPrepaiementPaid,
          nbResaPrepaiementUnPaid: esta.nbResaPrepaiementUnPaid,
          amountPrepaiementUnPaid: esta.amountPrepaiementUnPaid + '€',
          amountPrepaiementPaid: esta.amountPrepaiementPaid + '€',
          total: (esta.amountPrepaiementPaid + esta.amountCautionPaid) + '€'
        }
        tab.push(tmp)
      })
      return tab
    },
    getFilteredRestoInfos() {
      let rInfos = this.restosInfos
      if (this.restosInfos && this.typeResto !== '') {
        rInfos = Object.entries(this.restosInfos).filter(([index, r]) => {
          return r.type === this.typeResto
        })
        rInfos = Object.fromEntries(rInfos)
      }
      let results = rInfos
      if (this.searchResto !== '') {
        results = Object.entries(rInfos).filter(
          this.createFilter(this.searchResto.trim())
        )
        results = Object.fromEntries(results)
      }
      return results
    }
  },
  methods: {
    ...mapActions({
      loadIpsCheckEnabeld: 'loadIpsCheckEnabeld',
      loadAUsers: 'newUsers/loadAUsers',
      setNewPWD: 'newUsers/setNewPWD'
    }),
    updateDropdowns: function (val) {
      this.inputSearchResto = val.restoName
    },
    createFilter: function (queryString) {
      return ([index, r]) => {
        return (r.restoName.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    getStatsFormatted() {
      if (Object.entries(this.stats).length > 0) {
        let estas = []
        Object.entries(this.stats).forEach(([index, esta]) => {
          estas.push({
            name: esta.name,
            email: esta.email,
            total: Object.entries(esta.resas).length,
            nbSms: esta.nbSms,
            permanenceTotal: this.calcResaNbType(esta.resas, 'Permanence'),
            permanenceNoShow: this.calcResaNbType(esta.resas, 'Permanence', 'NO_SHOW'),
            permanenceCancel: this.calcResaNbType(esta.resas, 'Permanence', 'CANCELLED'),
            restoTotal: this.calcResaNbType(esta.resas, 'Restaurant'),
            restoNoShow: this.calcResaNbType(esta.resas, 'Restaurant', 'NO_SHOW'),
            restoCancel: this.calcResaNbType(esta.resas, 'Restaurant', 'CANCELLED'),
            webTotal: this.calcResaNbType(esta.resas, 'site web') + this.calcResaNbType(esta.resas, 'lyonresto') + this.calcResaNbType(esta.resas, 'tripadvisor') + this.calcResaNbType(esta.resas, 'yelp'),
            webNoShow: this.calcResaNbType(esta.resas, 'site web', 'NO_SHOW') + this.calcResaNbType(esta.resas, 'yelp', 'NO_SHOW') + this.calcResaNbType(esta.resas, 'tripadvisor', 'NO_SHOW') + this.calcResaNbType(esta.resas, 'lyonresto', 'NO_SHOW'),
            webCancel: this.calcResaNbType(esta.resas, 'site web', 'CANCELLED') + this.calcResaNbType(esta.resas, 'lyonresto', 'CANCELLED') + this.calcResaNbType(esta.resas, 'tripadvisor', 'CANCELLED') + this.calcResaNbType(esta.resas, 'yelp', 'CANCELLED'),
            facebookTotal: this.calcResaNbType(esta.resas, 'facebook'),
            facebookNoShow: this.calcResaNbType(esta.resas, 'facebook', 'NO_SHOW'),
            facebookCancel: this.calcResaNbType(esta.resas, 'facebook', 'CANCELLED'),
            instagramTotal: this.calcResaNbType(esta.resas, 'instagram'),
            instagramNoShow: this.calcResaNbType(esta.resas, 'instagram', 'NO_SHOW'),
            instagramCancel: this.calcResaNbType(esta.resas, 'instagram', 'CANCELLED'),
            googleTotal: this.calcResaNbType(esta.resas, 'google'),
            googleNoShow: this.calcResaNbType(esta.resas, 'google', 'NO_SHOW'),
            googleCancel: this.calcResaNbType(esta.resas, 'google', 'CANCELLED'),
            yelpTotal: this.calcResaNbType(esta.resas, 'yelp'),
            yelpNoShow: this.calcResaNbType(esta.resas, 'yelp', 'NO_SHOW'),
            yelpCancel: this.calcResaNbType(esta.resas, 'yelp', 'CANCELLED'),
            tripadvisorTotal: this.calcResaNbType(esta.resas, 'tripadvisor'),
            tripadvisorNoShow: this.calcResaNbType(esta.resas, 'tripadvisor', 'NO_SHOW'),
            tripadvisorCancel: this.calcResaNbType(esta.resas, 'tripadvisor', 'CANCELLED'),
            lyonrestoTotal: this.calcResaNbType(esta.resas, 'lyonresto'),
            lyonrestoNoShow: this.calcResaNbType(esta.resas, 'lyonresto', 'NO_SHOW'),
            lyonrestoCancel: this.calcResaNbType(esta.resas, 'lyonresto', 'CANCELLED')
          })
        })
        return estas
      } else {
        return []
      }
    },
    /**
     * Get number of resas of type
     */
    calcResaNbType(resas, source, typeState = '') {
      if (resas === undefined || Object.entries(resas).length === 0) return 0

      let findeded
      if (typeState !== '') {
        findeded = Object.entries(resas).filter(([index, resa]) => {
          return resa.source === source && resa.state === typeState
        })
      } else {
        findeded = Object.entries(resas).filter(([index, resa]) => {
          return resa.source === source
        })
      }

      return findeded.length
    },
    /**
     * Get restos infos
    */
    async getRestosInfos() {
      this.statLoading = true
      let restos = []
      await fetchGetHelper(ERequestType.USERS.GETALL, null, this.getnewUser.token).then(async res => {
        restos = res.data
        let tabOfEsta = {}
        await Promise.all(_.map(restos, async (resto) => {
          await fetchGetHelper(ERequestType.INFOS.GET, `restoid=${resto.restoid}`).then(resInfos => {
            if (resInfos.data !== '') {
              tabOfEsta[resto.restoid] = resInfos.data
              tabOfEsta[resto.restoid].type = resto.type
            }
          })
        }))
        this.restosInfos = tabOfEsta
        this.showAdminContent('AdminResto')
      })
    },
    /**
     * Get restos infos
    */
    async getGoogleRestosInfos() {
      this.statLoading = true
      let restos = []
      await fetchGetHelper(ERequestType.USERS.GETALL, null, this.getnewUser.token).then(async res => {
        restos = res.data
        let tabOfEsta = {}
        await Promise.all(_.map(restos, async (resto) => {
          await fetchGetHelper(ERequestType.INFOS.GET, `restoid=${resto.restoid}`).then(resInfos => {
            if (resInfos.data !== '') {
              tabOfEsta[resto.restoid] = resInfos.data
            }
          })
        }))
        this.restosInfos = tabOfEsta
        this.showAdminContent('Google')
      })
    },
    /**
     * Get restos infos
    */
    async getAppInfos() {
      this.appInfosLoading = true
      this.showAdminContent('AppInfos')
      try {
        await fetchGetHelper(ERequestType.APPINFOS.GET).then(res => {
          if (res && res.data !== '') {
            this.formAppInfos = res.data
          }
          this.appInfosLoading = false
        })
      } catch (err) {
        console.error(err)
      }
    },

    saveAppInfos() {
      this.$refs['formAppInfos'].validate((valid) => {
        if (valid) {
          fetchPutHelper(ERequestType.APPINFOS.UPDATE, this.formAppInfos, this.getnewUser.token)
            .then(res => {
              Notification.success({
                title: "Donnée mise à jour pour les infos de l'application",
                message: res,
                position: 'bottom-right'
              })
            }).catch(err => {
              Notification.error({
                title: 'Erreur',
                message: err.data.error,
                position: 'bottom-right'
              })
              console.error(err)
            })
        }
      })
    },

    /**
     * Modify password for selected resto
     */
    modifyPWD(restodId, restoid) {
      this.loadAUsers().then(() => {
        let userToModify = this.getAUsers.filter(u => {
          return u.id === restoid
        })[0]
        this.formPWDChange.email = userToModify.data.email
        this.formPWDChange.newEmail = userToModify.data.email
        this.changePWD = true
      })
    },

    /**
     * Modify option on line for resto
     */
    modifyRestoOption(restoId, permOn, mailRestoOn, smsRestoOn, smsRappelOn, stripe, bookingInverted) {
      if (!permOn) permOn = false
      if (!mailRestoOn) mailRestoOn = false
      if (!smsRestoOn) smsRestoOn = false
      if (!smsRappelOn) smsRappelOn = false
      if (!stripe) stripe = false
      let updatedDatas = {
        restoMailSended: mailRestoOn,
        clientSmsSended: smsRestoOn,
        rappelSmsSended: smsRappelOn,
        permanenceOn: permOn,
        restoStripe: stripe,
        restoid: restoId
      }
      fetchPutHelper(ERequestType.INFOS.UPDATE, updatedDatas, this.getnewUser.token).then(res => {
        Notification.success({
          title: 'Donnée mise à jour pour le restaurant',
          message: 'Données Sauvegardées',
          position: 'bottom-right'
        })
      }).catch(function (error) {
        // The document probably doesn't exist.
        console.error(error)
      })
    },

    /**
     * Modify option on line for resto
     */
    updateGoogleInfos(restoDatas) {
      fetchPutHelper(ERequestType.INFOS.UPDATE, restoDatas, this.getnewUser.token).then(res => {
        Notification.success({
          title: 'Donnée mise à jour pour le restaurant',
          message: 'Données Sauvegardées',
          position: 'bottom-right'
        })
      }).catch(function (error) {
        // The document probably doesn't exist.
        console.error(error)
      })
    },

    /**
     * delete resto
     */
    deleteResto(restoId, restoName) {
      this.$confirm(`Etes vous sûr de vouloir supprimer le restaurant ${restoName}`, 'Supprimer un restaurant', {
        confirmButtonText: 'Valider',
        cancelButtonText: 'Annuler',
        type: 'danger'
      }).then(() => {
        // TODO: delete resto
        fetchPostHelper(ERequestType.USERS.DELETE, `restoid=${restoId.toString()}`, this.getnewUser.token).then(res => {
          console.log(res)
        }).catch(err => {
          console.error(err)
        })
      }).catch((err) => {
        Notification.error({
          title: 'Erreur',
          message: err.message,
          position: 'bottom-right'
        })
      })
    },

    /**
     * change email login
     */
    changeMailLogin() { },

    /**
     * Get stripe datas
     */
    async getStripeDatas() {
      this.stripeLoading = true
      let tabOfEsta = {}
      // Paid cashresas
      await fetchGetHelper(ERequestType.CASHRESAS.ALL_PAID_FROM, `from=${this.valueMinCalendar.toString()}`, this.getnewUser.token).then(res => {
        res.data.forEach(cashResa => {
          if (!tabOfEsta[cashResa.restoid]) Vue.set(tabOfEsta, cashResa.restoid, {})
          if (!tabOfEsta[cashResa.restoid].resasPaid) Vue.set(tabOfEsta[cashResa.restoid], 'resasPaid', {})
          Vue.set(tabOfEsta[cashResa.restoid].resasPaid, cashResa.id, cashResa)
          // caution
          if (!tabOfEsta[cashResa.restoid].nbResaCaution) Vue.set(tabOfEsta[cashResa.restoid], 'nbResaCaution', 0)
          if (!tabOfEsta[cashResa.restoid].nbResaCautionPaid) Vue.set(tabOfEsta[cashResa.restoid], 'nbResaCautionPaid', 0)
          if (!tabOfEsta[cashResa.restoid].nbResaCautionUnPaid) Vue.set(tabOfEsta[cashResa.restoid], 'nbResaCautionUnPaid', 0)
          if (!tabOfEsta[cashResa.restoid].amountCautionUnPaid) Vue.set(tabOfEsta[cashResa.restoid], 'amountCautionUnPaid', 0)
          if (!tabOfEsta[cashResa.restoid].amountCautionPaid) Vue.set(tabOfEsta[cashResa.restoid], 'amountCautionPaid', 0)
          // prepaiement
          if (!tabOfEsta[cashResa.restoid].nbResaPrepaiement) Vue.set(tabOfEsta[cashResa.restoid], 'nbResaPrepaiement', 0)
          if (!tabOfEsta[cashResa.restoid].nbResaPrepaiementPaid) Vue.set(tabOfEsta[cashResa.restoid], 'nbResaPrepaiementPaid', 0)
          if (!tabOfEsta[cashResa.restoid].nbResaPrepaiementUnPaid) Vue.set(tabOfEsta[cashResa.restoid], 'nbResaPrepaiementUnPaid', 0)
          if (!tabOfEsta[cashResa.restoid].amountPrepaiementUnPaid) Vue.set(tabOfEsta[cashResa.restoid], 'amountPrepaiementUnPaid', 0)
          if (!tabOfEsta[cashResa.restoid].amountPrepaiementPaid) Vue.set(tabOfEsta[cashResa.restoid], 'amountPrepaiementPaid', 0)
          // update count
          if (cashResa.type === 'caution') {
            tabOfEsta[cashResa.restoid].nbResaCaution += 1
            tabOfEsta[cashResa.restoid].nbResaCautionPaid += 1
            tabOfEsta[cashResa.restoid].amountCautionPaid += parseInt(cashResa.total)
          } else {
            tabOfEsta[cashResa.restoid].nbResaPrepaiement += 1
            tabOfEsta[cashResa.restoid].nbResaPrepaiementPaid += 1
            tabOfEsta[cashResa.restoid].amountPrepaiementPaid += parseInt(cashResa.total)
          }
        })
      })
      // un paid cashresas
      await fetchGetHelper(ERequestType.CASHRESAS.ALL_UNPAID, `from=${this.valueMinCalendar.toString()}`, this.getnewUser.token).then(res => {
        res.data.forEach(cashResa => {
          if (!tabOfEsta[cashResa.restoid]) Vue.set(tabOfEsta, cashResa.restoid, {})
          if (!tabOfEsta[cashResa.restoid].resasUnPaid) Vue.set(tabOfEsta[cashResa.restoid], 'resasUnPaid', {})
          Vue.set(tabOfEsta[cashResa.restoid].resasUnPaid, cashResa.id, cashResa)
          // caution
          if (!tabOfEsta[cashResa.restoid].nbResaCaution) Vue.set(tabOfEsta[cashResa.restoid], 'nbResaCaution', 0)
          if (!tabOfEsta[cashResa.restoid].nbResaCautionPaid) Vue.set(tabOfEsta[cashResa.restoid], 'nbResaCautionPaid', 0)
          if (!tabOfEsta[cashResa.restoid].nbResaCautionUnPaid) Vue.set(tabOfEsta[cashResa.restoid], 'nbResaCautionUnPaid', 0)
          if (!tabOfEsta[cashResa.restoid].amountCautionUnPaid) Vue.set(tabOfEsta[cashResa.restoid], 'amountCautionUnPaid', 0)
          if (!tabOfEsta[cashResa.restoid].amountCautionPaid) Vue.set(tabOfEsta[cashResa.restoid], 'amountCautionPaid', 0)
          // prepaiement
          if (!tabOfEsta[cashResa.restoid].nbResaPrepaiement) Vue.set(tabOfEsta[cashResa.restoid], 'nbResaPrepaiement', 0)
          if (!tabOfEsta[cashResa.restoid].nbResaPrepaiementPaid) Vue.set(tabOfEsta[cashResa.restoid], 'nbResaPrepaiementPaid', 0)
          if (!tabOfEsta[cashResa.restoid].nbResaPrepaiementUnPaid) Vue.set(tabOfEsta[cashResa.restoid], 'nbResaPrepaiementUnPaid', 0)
          if (!tabOfEsta[cashResa.restoid].amountPrepaiementUnPaid) Vue.set(tabOfEsta[cashResa.restoid], 'amountPrepaiementUnPaid', 0)
          if (!tabOfEsta[cashResa.restoid].amountPrepaiementPaid) Vue.set(tabOfEsta[cashResa.restoid], 'amountPrepaiementPaid', 0)
          if (cashResa.type === 'caution') {
            tabOfEsta[cashResa.restoid].nbResaCaution += 1
            tabOfEsta[cashResa.restoid].nbResaCautionUnPaid += 1
            tabOfEsta[cashResa.restoid].amountCautionUnPaid += parseInt(cashResa.total)
          } else {
            tabOfEsta[cashResa.restoid].nbResaPrepaiement += 1
            tabOfEsta[cashResa.restoid].nbResaPrepaiementUnPaid += 1
            tabOfEsta[cashResa.restoid].amountPrepaiementUnPaid += parseInt(cashResa.total)
          }
        })
      })
      // get name esta
      await Promise.all(_.map(tabOfEsta, async (arrayOfDay, idEsta) => {
        // get name of establishement
        let name = idEsta
        await fetchGetHelper(ERequestType.INFOS.GET, `restoid=${idEsta}`).then(res => {
          if (res.data && res.data.restoName && res.data.restoName !== '') name = res.data.restoName
        })

        let email = 'none'
        if (this.getUser.user.email) email = this.getUser.user.email

        // push datas
        if (tabOfEsta[idEsta]) {
          Vue.set(tabOfEsta[idEsta], 'name', name)
          Vue.set(tabOfEsta[idEsta], 'email', email)
        }
      }))

      this.stripeTable = tabOfEsta
      this.stripeLoading = false
    },

    /**
     * Get stats permanence Dats
     */
    async getStatsPermDatas() {
      this.statLoading = true
      // clean existing stats
      Vue.set(this, 'stats', {})
      try {
        // get all users
        let aUsers = []
        await fetchGetHelper(ERequestType.USERS.GETALL, null, this.getnewUser.token).then(res => {
          aUsers = res.data
        })

        // get all resto infos
        let aInfos = []
        await fetchGetHelper(ERequestType.INFOS.GETALL, null, this.getnewUser.token).then(res => {
          aInfos = res.data
        })

        // get all resas
        let tabOfEsta = {}
        let dateMin = new Date(this.valueMinCalendar)
        let dateMax = new Date(this.valueMaxCalendar)
        let minTS = dateToTimeStamp(dateMin.getDate(), dateMin.getMonth(), dateMin.getFullYear())
        let maxTS = dateToTimeStamp(dateMax.getDate(), dateMax.getMonth(), dateMax.getFullYear())
        // get resas for each esta between too dates
        await fetchGetHelper(ERequestType.RESAS.GET_ALL_TS_TO_TS, `minTs=${minTS}&maxTs=${maxTS}`, this.getnewUser.token).then(res => {
          res.data.forEach(resa => {
            if (!tabOfEsta[resa.restoid]) Vue.set(tabOfEsta, resa.restoid, [])
            tabOfEsta[resa.restoid].push(resa)
          })
        })
        let smsTab = []
        await fetchGetHelper(ERequestType.SMS.GET_ALL_TS_TO_TS, `minTs=${minTS}&maxTs=${maxTS}`, this.getnewUser.token).then(res => {
          smsTab = res.data
        })

        await Promise.all(_.map(aInfos, async (info, idEsta) => {
          let name = idEsta
          let email = 'none'
          let sms = smsTab.filter(sms => sms.restoid === info.restoid)
          let user = aUsers.find(el => el.restoid === info.restoid)
          if (user) {
            email = user.email
          }
          this.stats[info.restoid] = {
            name: info.restoName ? info.restoName : name,
            email: email,
            nbSms: sms.length,
            resas: tabOfEsta[info.restoid] ? tabOfEsta[info.restoid] : []
          }
        }))

        this.statsTable = this.getStatsFormatted()
        this.statLoading = false
      } catch (err) {
        this.statLoading = false
        console.error(`erreur${err}`)
      }
    },
    exportStats: function () {
      let items = this.getStatsTable.slice(0)
      let csv = Papa.unparse(items)
      let fileName = `Stats-${this.valueMinCalendar.getDate()}-${this.valueMinCalendar.getMonth()}-${this.valueMinCalendar.getFullYear()}-to-${this.valueMaxCalendar.getDate()}-${this.valueMaxCalendar.getMonth()}-${this.valueMaxCalendar.getFullYear()}.csv`
      this.fileToDownload(fileName, csv)
    },
    exportStatsStripe: function () {
      let items = this.getStripeTable.slice(0)
      let csv = Papa.unparse(items)
      let fileName = `StatsStripe-from-${this.valueMinCalendar.getDate()}-${this.valueMinCalendar.getMonth()}-${this.valueMinCalendar.getFullYear()}.csv`
      this.fileToDownload(fileName, csv)
    },
    fileToDownload: function (filename, text) {
      var element = document.createElement('a')
      element.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(text)}`)
      element.setAttribute('download', filename)

      element.style.display = 'none'
      document.body.appendChild(element)

      element.click()

      document.body.removeChild(element)
    },
    showAdminContent(panel) {
      this.panelShow = panel
    },
    signUp: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store.dispatch('newUsers/signUp', this.formSignUp).then(
            (data) => {
              Notification.success({
                title: 'New user',
                message: data,
                position: 'bottom-right'
              })
              this.interval = window.setInterval(() => {
                window.clearInterval(this.interval)
                window.location.reload()
              }, 4000)
            },
            function (err) {
              console.error(`fail : ${err}`)
              // TODO: show toast
              Notification.error({
                title: 'Error',
                message: err.message,
                position: 'bottom-right'
              })
            }
          )
        } else {
          return false
        }
      })
    },
    logout: function () {
      this.$store.dispatch('newUsers/logout')
    },
    checkPassWord: function (rule, value, callback) {
      if (value === '') {
        callback(new Error('Veuillez entrer à nouveau le mot de passe'))
      } else if (value !== this.formPWDChange.newPassword) {
        callback(new Error('Les deux entrées ne correspondent pas!'))
      } else {
        callback()
      }
    },
    submitFormPWD: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.setNewPWD({
            email: this.formPWDChange.email,
            newPassword: this.formPWDChange.newPassword,
            newEmail: this.formPWDChange.newEmail
          }).then(res => {
            console.log(res)
            if (res) this.closeChangePWD()
          })
        } else {
          return false
        }
      })
    },
    closeChangePWD: function () {
      this.changePWD = false
      this.formPWDChange.newPassword = ''
      this.formPWDChange.newPasswordCheck = ''
      this.formPWDChange.newEmail = ''
    }
  },
  watch: {
    'getUser': function (val, oldVal) {
      if (val.role !== 'SuperAdmin' && val.role !== 'Admin') {
        this.$router.replace('restaurant')
      }
    }
  },
  created: function () {
    // if user isn't an admin back to resto
    if (this.getUser && this.getUser.user.role !== 'SuperAdmin' && this.getUser.user.role !== 'Admin') {
      this.$router.replace('restaurant')
    }
    // get ipsCheck value
    this.loadIpsCheckEnabeld().then(res => {
      this.ipControlEnable = res
    })
    // get options langues
    this.langueOptions = [
      {
        value: 'fr',
        label: 'Français'
      }
    ]
    // restaurant type
    this.restaurantType = [
      {
        value: 'classique',
        label: 'Classique'
      }
    ]
    this.rulesForm = {
      email: [
        { required: true, message: 'Merci de rentrer une adresse e-mail', trigger: 'blur' },
        { type: 'email', message: 'Merci de rentrer une adresse e-mail valide', trigger: 'blur' }
      ],
      name: [
        { required: true, message: 'Merci de rentrer un nom', trigger: 'blur' }
      ],
      secondname: [
        { required: true, message: 'Merci de rentrer un prénom', trigger: 'blur' }
      ],
      adresse: [
        { required: true, message: 'Merci de compléter l adresse', trigger: 'blur' }
      ],
      codera: [
        { required: true, message: 'Merci de rentrer un code RA', trigger: 'blur' }
      ],
      required: [
        { required: true, message: 'Merci de renseigner le champ', trigger: 'blur' }
      ],
      password: [
        { required: true, message: 'Merci de rentrer un mot de passe', trigger: 'blur' },
        { min: 6, message: 'Merci de rentrer un mot de passe de plus de 6 caractères', trigger: 'blur' }
      ]
    }
    this.rulesFormAppInfos = {
      version: [
        { required: true, message: 'Merci de rentrer une version', trigger: 'blur' }
      ]
    }
    this.rulesFormPWDChange = {
      password: [
        { required: true, message: 'Merci de renseigner le champ', trigger: 'blur' }
      ],
      newPassword: [
        { required: true, message: 'Merci de renseigner le champ', trigger: 'blur' }
      ],
      newPasswordCheck: [
        { required: true, message: 'Merci de renseigner le champ', trigger: 'blur' },
        { validator: this.checkPassWord, trigger: 'blur' }
      ],
      newEmail: [
        { required: true, message: 'Merci de rentrer une adresse e-mail', trigger: 'blur' },
        { type: 'email', message: 'Merci de rentrer une adresse e-mail valide', trigger: 'blur' }
      ]
    }
  },
  components: {
    Services
  }
}
</script>

<style lang="scss">
@use "../styles/components/layout/logapp";
@use "../styles/components/elements/notif";

.admin {
  &-container2 {
    margin-top: 10px;
    height: 100dvh;
    overflow-y: scroll;
  }

  &-pannel {
    padding: 10px;

    .el-col {
      text-align: center;
    }
  }

  &-console {
    margin: 25px;
    padding: 15px;
  }

  &-resto {
    &-title {
      font-size: 22px;
      padding: 10px 10px;
    }

    &-line {
      padding: 10px;
      border-top: 1px solid #999;

      &:last-child {
        border-bottom: 1px solid #999;
      }

      &_header {
        background-color: #e4e4e4;
      }
    }
  }
}

.dateChooser {
  padding: 20px;
}

.logapp {
  margin-bottom: 20vh;
}

.datePicker {
  width: 100% !important;
}
</style>
